import { __exports as n } from "../../../../_virtual/matches.js";
Object.defineProperty(n, "__esModule", { value: !0 });
n.matches = void 0;
function a(e, t, r) {
  var g = String(t).length, s = e.substr(0, g), u = parseInt(s, 10);
  return t = parseInt(String(t).substr(0, s.length), 10), r = parseInt(String(r).substr(0, s.length), 10), u >= t && u <= r;
}
function h(e, t) {
  return t = String(t), t.substring(0, e.length) === e.substring(0, t.length);
}
function i(e, t) {
  return Array.isArray(t) ? a(e, t[0], t[1]) : h(e, t);
}
n.matches = i;
export {
  n as default
};
